import React, { Component } from "react";
import { Row, Col, Input, Form, Button } from "reactstrap";
import { toast } from "react-toastify";
import { updateCashierConfig } from "../../services/globalStreamConfigService";
import getDeepModels from "../../services/deepModelService";
import cloneDeep from "../../utils/parseUtils";

class CashierForm extends Component {
  state = {
    backupCashierConfig: null,
    inputFixedCameraTr: null,
    inputDeepModelId: null,
    deepModels: [],
    confirmSave: false,
  };

  async componentDidMount() {
    const { cashierConfig: cashierConfigProp } = this.props;
    const cashierConfig = cloneDeep(cashierConfigProp);
    const backupCashierConfig = cloneDeep(cashierConfig);
    let deepModels = [];
    try {
      const { data } = await getDeepModels();
      deepModels = data || [];
    } catch (err) {
      console.error("Failed to load deep models", err);
    }
    this.setState({
      backupCashierConfig,
      inputFixedCameraTr: cashierConfig.fixed_camera_tr != null ? String(cashierConfig.fixed_camera_tr) : null,
      inputDeepModelId: cashierConfig.deep_model ?? null,
      deepModels,
    });
  }

  componentDidUpdate(prevProps) {
    const { cashierConfig: cashierConfigProp } = this.props;
    const { cashierConfig: prevCashierConfig } = prevProps;
    if (prevCashierConfig !== cashierConfigProp) {
      const cashierConfig = cloneDeep(cashierConfigProp);
      const backupCashierConfig = cloneDeep(cashierConfig);
      this.setState({
        backupCashierConfig,
        inputFixedCameraTr: cashierConfig.fixed_camera_tr != null ? String(cashierConfig.fixed_camera_tr) : null,
        inputDeepModelId: cashierConfig.deep_model ?? null,
      });
    }
  }

  reset = () => {
    this.setState((prevState) => {
      const { backupCashierConfig } = prevState;
      return {
        inputFixedCameraTr:
          backupCashierConfig.fixed_camera_tr != null ? String(backupCashierConfig.fixed_camera_tr) : null,
        inputDeepModelId: backupCashierConfig.deep_model ?? null,
      };
    });
  };

  save = async () => {
    const { inputFixedCameraTr, inputDeepModelId } = this.state;
    const { onSave } = this.props;
    const fixedCameraTr =
      inputFixedCameraTr === "" || inputFixedCameraTr === null ? null : parseFloat(inputFixedCameraTr);

    if (fixedCameraTr !== null && Number.isNaN(fixedCameraTr)) {
      toast.error("Invalid Fixed Camera TR value");
      return;
    }

    const deepModel = inputDeepModelId === "" || inputDeepModelId === null ? null : Number(inputDeepModelId);
    if (deepModel !== null && Number.isNaN(deepModel)) {
      toast.error("Invalid Cashier Deep Model selection");
      return;
    }

    try {
      await updateCashierConfig({
        fixed_camera_tr: fixedCameraTr,
        deep_model: deepModel,
      });
      const backupCashierConfig = { fixed_camera_tr: fixedCameraTr, deep_model: deepModel };
      this.setState({
        backupCashierConfig,
        inputFixedCameraTr: fixedCameraTr != null ? String(fixedCameraTr) : null,
        inputDeepModelId: deepModel,
      });
      this.toggleConfirmSave();
      onSave?.();
      toast.success("Cashier config saved successfully");
    } catch (error) {
      toast.error("Error saving cashier config");
      console.error(error);
    }
  };

  toggleConfirmSave = () => {
    this.setState((prevState) => {
      const { confirmSave } = prevState;
      return { confirmSave: !confirmSave };
    });
  };

  onInputChange = (field, value) => {
    if (field === "fixedCameraTr") {
      this.setState({ inputFixedCameraTr: value === "" ? null : value });
    }
    if (field === "deepModelId") {
      this.setState({ inputDeepModelId: value === "" ? null : value });
    }
  };

  render() {
    const { backupCashierConfig, inputFixedCameraTr, inputDeepModelId, deepModels, confirmSave } = this.state;

    if (!backupCashierConfig) {
      return null;
    }

    return (
      <Form className="mt-3">
        <Row>
          <Col md="4">
            <h5>Cashier Settings</h5>
            <div className="input-group mb-3">
              <span className="mr-2 mt-2">Fixed Camera TR:</span>
              <Input
                className="form-control border border-dark rounded"
                type="number"
                step="any"
                value={inputFixedCameraTr ?? ""}
                onChange={(e) => this.onInputChange("fixedCameraTr", e.target.value)}
              />
            </div>
            <div className="input-group mb-3">
              <span className="mr-2 mt-2">Cashier Deep Model:</span>
              <Input
                className="form-control border border-dark rounded"
                type="select"
                value={inputDeepModelId ?? ""}
                onChange={(e) => this.onInputChange("deepModelId", e.target.value)}
              >
                <option value="">None — use store default</option>
                {deepModels.map((model) => (
                  <option key={model.id} value={model.id}>
                    {model.name}
                  </option>
                ))}
              </Input>
            </div>
            <div>
              <Button className="float-right m-2" onClick={this.reset}>
                <i className="fas fa-times mr-2" /> Reset
              </Button>
            </div>
            {!confirmSave && (
              <div>
                <Button className="float-right btn-success m-2" onClick={this.toggleConfirmSave}>
                  <i className="fas fa-save mr-2" /> Save
                </Button>
              </div>
            )}
            {confirmSave && (
              <div className="save-confirmation">
                <Button className="float-right m-2" onClick={this.toggleConfirmSave}>
                  <i className="fas fa-times mr-2" /> Cancel
                </Button>
                <Button className="float-right btn-success m-2" onClick={this.save}>
                  <i className="fas fa-save mr-2" /> Save
                </Button>
                <span className="float-right">Are you sure?</span>
              </div>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}

export default CashierForm;
